/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $PlayerStatisticsMedium = {
    properties: {
        value: {
            type: 'string',
            isRequired: true,
        },
        player: {
            type: 'PlayerMedium',
            isRequired: true,
        },
        placement: {
            type: 'number',
            isRequired: true,
        },
    },
} as const;
